import { hasValue } from 'src/shared/NullUtil';
import { VimeoLinkParser } from 'src/shared/VimeoParser/VimeoLinkParser';
import { VimeoParser } from 'src/shared/VimeoParser/VimeoParser';
import { VimeoPlayerParser } from 'src/shared/VimeoParser/VimeoPlayerParser';

export * from './VimeoParser';

export const defaultVimeoParsers: VimeoParser[] = [
    new VimeoLinkParser('a', 'href'),
    new VimeoPlayerParser('iframe', 'src'),
    new VimeoPlayerParser('object', 'data')
];

/**
 * Checks if the given url is a valid Vimeo url
 * @param url   The url to check
 * @return      `true` if the url is a valid Vimeo url, otherwise `false`
 */
export function isValidVimeoUrl(url: string): boolean {
    return defaultVimeoParsers.map((parser) => parser.extract(url)).some(hasValue);
}
